import { render, staticRenderFns } from "./studentsIndex.vue?vue&type=template&id=1e2d606d&"
import script from "./studentsIndex.vue?vue&type=script&lang=js&"
export * from "./studentsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports